module.exports = __webpack_public_path__ + "img/number_4.a13d2eda.png";